/* global Swiper */

/**
 * Calculate and set grid row height based on image column width and aspect ratio
 */
(function () {
	'use strict';

	// Image dimensions for aspect ratio calculations
	const IMAGE_WIDTH = 840;
	const IMAGE_HEIGHT = 550;
	const DESKTOP_BREAKPOINT = 1200.99;

	/**
	 * Check if we're on desktop
	 * @return {boolean} True if viewport width is desktop or larger
	 */
	function isDesktop() {
		return window.innerWidth >= DESKTOP_BREAKPOINT;
	}

	/**
	 * Set grid-template-columns based on layout type and settings
	 * @param {HTMLElement} wrapper - The agenda__general wrapper element
	 */
	function setGridTemplateColumns(wrapper) {
		if (!isDesktop()) {
			wrapper.style.setProperty('--grid-template-columns', '');
			return;
		}

		const layoutType =
			wrapper.getAttribute('data-grid-layout-type') || 'proportional';

		if (layoutType === 'chess') {
			const gap =
				parseFloat(wrapper.getAttribute('data-chess-gap')) || 0.8;
			wrapper.style.setProperty(
				'--grid-template-columns',
				`calc(50% - ${gap}rem) 1fr`
			);
		} else if (layoutType === 'proportional') {
			const col1 =
				parseInt(wrapper.getAttribute('data-proportional-col1'), 10) ||
				840;
			const col2 =
				parseInt(wrapper.getAttribute('data-proportional-col2'), 10) ||
				780;
			wrapper.style.setProperty(
				'--grid-template-columns',
				`${col1}fr ${col2}fr`
			);
		}
	}

	/**
	 * Set aspect ratio on image element
	 * @param {HTMLElement} wrapper - The wrapper element
	 */
	function setAspectRatio(wrapper) {
		const imageCol = wrapper.querySelector('.agenda__image');
		if (imageCol) {
			imageCol.style.aspectRatio = IMAGE_WIDTH / IMAGE_HEIGHT;
		}
	}

	/**
	 * Set grid row height based on image column width
	 * @param {HTMLElement} wrapper - The agenda__general wrapper element
	 */
	function setRowHeight(wrapper) {
		if (!isDesktop()) {
			// Reset to auto on mobile
			wrapper.style.gridTemplateRows = '';
			return;
		}

		const imageCol = wrapper.querySelector('.agenda__image');
		if (!imageCol) {
			return;
		}

		// Use getBoundingClientRect for more accurate width
		const imageColWidth = imageCol.getBoundingClientRect().width;

		if (imageColWidth > 0) {
			const rowHeight = imageColWidth * (IMAGE_HEIGHT / IMAGE_WIDTH);
			wrapper.style.gridTemplateRows = rowHeight + 'px';
		}
	}

	/**
	 * Initialize agenda height calculations
	 */
	function initAgenda() {
		const wrappers = document.querySelectorAll('.agenda__general');
		wrappers.forEach((wrapper) => {
			setAspectRatio(wrapper);
			setGridTemplateColumns(wrapper);
			setRowHeight(wrapper);
		});
	}

	/**
	 * Debounce helper
	 * @param {Function} func - Function to debounce
	 * @param {number}   wait - Wait time in milliseconds
	 * @return {Function} Debounced function
	 */
	function debounce(func, wait) {
		let timeout;
		return function (...args) {
			clearTimeout(timeout);
			timeout = setTimeout(() => func.apply(this, args), wait);
		};
	}

	// Initialize height calculations
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initAgenda);
	} else {
		initAgenda();
	}

	// Handle resize
	const handleResize = debounce(initAgenda, 150);
	window.addEventListener('resize', handleResize);

	// Handle image load
	document.querySelectorAll('.agenda__image img').forEach((img) => {
		if (img.complete) {
			initAgenda();
		} else {
			img.addEventListener('load', initAgenda, { once: true });
		}
	});

	// Handle dynamic content (for WordPress/Gutenberg)
	if (typeof wp !== 'undefined' && wp.domReady) {
		wp.domReady(initAgenda);
	}

	document.addEventListener('DOMContentLoaded', function () {
		var onSwiperReady = window.mobidevOnSwiperReady || function (cb) {
			if (typeof Swiper !== 'undefined') {
				cb();
			}
		};
		onSwiperReady(function () {
			document
				.querySelectorAll('.agenda__slider')
				.forEach(function (slider) {
					const container = slider.closest('.agenda');
					if (!container) {
						return;
					}

					const nextButton = container.querySelector(
						'.agenda__navigation-button--next'
					);
					const prevButton = container.querySelector(
						'.agenda__navigation-button--prev'
					);
					const duration = 600;

					new Swiper(slider, {
						slidesPerView: 1,
						spaceBetween: 0,
						loop: false,
						speed: duration,
						navigation: {
							nextEl: nextButton,
							prevEl: prevButton,
						},
						on: {
							init() {
								setWidth(container, nextButton);
							},
							resize() {
								setWidth(container, nextButton);
								this.update();
							},
						},
					});
				});
		});
	});

	function setWidth(container, button) {
		const navigation = container.querySelector('.agenda__navigation');
		if (navigation && button) {
			const navWidth = navigation.offsetWidth;
			const buttonWidth = button.offsetWidth;
			container.style.setProperty(
				'--nav-width',
				navWidth - buttonWidth + 'px'
			);
		}
	}
})();
